export enum OrderType {
    Ascending = 0,
    Descending = 1
}